import { render, staticRenderFns } from "./Lianjie.vue?vue&type=template&id=a5f00ee4&scoped=true"
import script from "./Lianjie.vue?vue&type=script&lang=js"
export * from "./Lianjie.vue?vue&type=script&lang=js"
import style0 from "./Lianjie.vue?vue&type=style&index=0&id=a5f00ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f00ee4",
  null
  
)

export default component.exports